import { useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import "./scss/report.scss"
import { Table, Spin, Tabs } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import { Tag } from "rsuite"
import StorageService from "../../utils/storage.service";
import Loading from "../customer/Loading";
import _ from "lodash"

const ReportServiceChuaThucHien = () => {
    const title = "Doanh thu chưa thực hiện"
    const userAdmin = JSON.parse(StorageService.getItem("user_info"))

    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [tableFull, setTableFull] = useState([])
    const [tableOwed, setTableOwed] = useState([])
    const [tableStore, setTableStore] = useState([])

    const [keyword, setKeyword] = useState([])
    const [totalFullPaid, setTotalFullPaid] =   useState(0)
    const [totalOwedPaid, setTotalOwedPaid] =   useState(0)

    const [showLoading, setShowLoading] = useState(false)
    const [optionCategory, setOptionCategory] = useState([])
    const [catId, setCatId] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [typeBHVV, setTypeBHVV] = useState(0)


    const handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }

    const handleCategory = (x) => {
        setCatId(x)
    }
    const fetchData = async (sD, eD, s) => {
        let payload = {
            store,
            typeBHVV,
            type: 2
        }
        const res = await axiosService(`api/mysql/report-store/chua-phuc-vu`, "POST", payload)

        if (res.data.code === 200) {
            setLoading(false)
            const { dataFullPaid, dataOwedPaid, totalFullPaid, totalOwedPaid, tableStore } = res.data.data
            setTableFull(dataFullPaid)
            setTableOwed(dataOwedPaid)
            setTotalFullPaid(totalFullPaid)
            setTotalOwedPaid(totalOwedPaid)
            setTableStore(tableStore)
        }

    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(store, typeBHVV)
    }, [store, typeBHVV])

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const columns = [
        {
            title: 'Mã hoá đơn',
            dataIndex: 'order_code',
            render: (data) => {
                return (
                    <>
                        <p>{data}</p>
                    </>
                )
            },
        },
        {
            title: 'Ngày lên đơn hàng',
            dataIndex: 'order_at',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            title: 'Mã thẻ',
            dataIndex: 'package_code',
            align: "center",
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
        {
            title: 'Tên dịch vụ',
            dataIndex: 'product_name',
            align: "center",
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
        {
            title: 'Số buổi còn lại',
            dataIndex: 'count_used',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.count_used - b.count_used,
                multiple: 3,
            },
        },
        {
            title: 'Doanh thu chưa thực hiện',
            dataIndex: 'using_pice',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.using_pice - b.using_pice,
                multiple: 3,
            },
        },
        {
            title: 'Số tiền nợ',
            dataIndex: 'owed',
            align: "center",
            render: (data) => {
                return (
                    <p className="text2">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.using_pice - b.using_pice,
                multiple: 3,
            },
        },
        {
            title: 'Cơ sở',
            dataIndex: 'store_name',
            align: "center",
            render: (data) => {
                return (
                    <p className="text6">{data}</p>
                )
            },
        },
    ];

    const columns2 = [
        {
            title: 'Cơ sở',
            dataIndex: 'store_name',
            render: (data) => {
                return (
                    <>
                        <p>{data}</p>
                    </>
                )
            },
        },
        {
            title: 'Doanh thu chưa thực hiện đã thanh toán ',
            dataIndex: 'total_full',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Doanh thu chưa thực hiện đơn nợ',
            dataIndex: 'total_u_owed',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Tổng nợ',
            dataIndex: 'total_owed',
            align: "center",
            render: (data) => {
                return (
                    <p className="text3">{convertCurrency(Number(data))}</p>
                )
            },
        },
       
    ];

    const handleExportData = () => {
        setShowLoading(true)
      
        let url = `api/mysql/report-store/chua-phuc-vu?type=1&storeId=${store}`
        axiosService(url, "GET")
        .then((res) => {
            if (res.data.code == 200) {
                window.location.href = res.data.data.url
                setShowLoading(false)
            }
        }).catch((error) => {
            console.log(error)
            setShowLoading(false)
        });
    }

    const onChangeKeyword = (e) => {
        setKeyword(e)
    }

    const tabItems = [
        {
            key: '1',
            label: 'Khách đã thanh toán hoàn toàn',
            children: (
                <Table 
                    columns={columns} 
                    dataSource={tableFull}
                    onChange={handleChange}
                    pagination={{
                    pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '30', '50', '100']
                    }}
                    scroll={{ x: columns.length * 150, y: 600 }}
                    bordered
                    rowKey="package_code"
                />
            ),
        },
        {
            key: '2',
            label: 'Khách còn nợ',
            children: (
                <Table 
                    columns={columns} 
                    dataSource={tableOwed}
                    onChange={handleChange}
                    pagination={{
                    pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '30', '50', '100']
                    }}
                    scroll={{ x: columns.length * 170, y: 600 }}
                    bordered
                    rowKey="package_code"
                />
            ),
        },
    ];

    if (userAdmin.role === 1) {
        tabItems.push({
            key: '3',
            label: 'Thống kê theo cơ sở',
            children: (
                <Table 
                    columns={columns2} 
                    dataSource={tableStore}
                    onChange={handleChange}
                    pagination={{
                    pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '30', '50', '100']
                    }}
                    scroll={{ x: columns.length * 170, y: 600 }}
                    bordered
                    rowKey="store_name"
                />
            ),
        });
    }

    return (
        <div className={`container-fluid ${styles.background}`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} 
                store={store}
                typeBHVV={typeBHVV} setTypeBHVV={setTypeBHVV}
                handleStore={handleStore}
                title={title} type={"report-chua-phuc-vu"}
                csvData={tableFull} isExport={isExport}
                handleExportData={handleExportData}
                onChangeKeyword={onChangeKeyword}
                header={
                    [
                        { label: 'Tên dịch vụ', key: "product_name" },
                        { label: "Nhóm dịch vụ", key: "category_name" },
                        { label: "Tiền thực thu dịch vụ", key: "total_paid" },
                        { label: "Số dịch vụ bán mới", key: "count_order" },
                        { label: "Doanh số thuần", key: "total_price" },
                    ]
                }
                userAdmin={userAdmin}
                optionCategory={optionCategory}
                handleCategory={handleCategory}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <Row>
                    <Col xs={12} md={8}>
                        <Row className="mh-172">
                            <Col xs={6}>
                                <Tag color="green" className=" w-100 h-100 p-2">
                                    <p className={styles.textTag2}>TỔNG QUAN DOANH THU CHƯA THỰC HIỆN</p>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <br/>
                                            <p className={styles.textTag3}>Đơn đã hoàn thành thanh toán</p>
                                            <p className={styles.textTag3}>Đơn còn nợ</p>
                                        </div>
                                        <div>
                                            <br/>
                                            <p className={styles.textTag2}>{convertCurrency(totalFullPaid || 0)}</p>
                                            <p className={styles.textTag2}>{convertCurrency(totalOwedPaid || 0)}</p>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} className="mt-3">
                        <Tabs defaultActiveKey="1" items={tabItems} />
                    </Col>
                </Row>
            </Spin>
            <Loading show={showLoading} />
        </div>
    )
}
export default ReportServiceChuaThucHien